import type { EventTimeFilter } from "@hey-lady/shared/types/graphql";
import type { EventFilters } from "../consts";

export const getEventTimeFiltersFromParam = (
  eventTimeParam: string | null,
  defaultEventTimeFilters: EventTimeFilter[],
): EventTimeFilter[] => {
  if (eventTimeParam === null) {
    return [...defaultEventTimeFilters];
  }

  return eventTimeParam.split(",").filter(Boolean) as EventTimeFilter[];
};

export const preserveEventTimeFilters = (
  nextFilters: EventFilters["events"],
  currentFilters: EventFilters["events"],
): EventFilters["events"] => ({
  ...nextFilters,
  eventTime: currentFilters.eventTime,
  customTimeFrom: currentFilters.customTimeFrom,
  customTimeUntil: currentFilters.customTimeUntil,
});
